import type { Validation } from "@/lib/validation"
import { buildElementPath } from "@/lib/validation/buildElementPath"

export const buildFailureReport = <
  Registry extends Validation.BaseRegistry,
  Element
>({
  api,
  element,
  expectation,
  failures,
  path,
}: {
  api: Validation.API<Registry>
  element: unknown
  expectation: Validation.Expectation<Registry, Element>
  failures: Validation.Failure[]
  path: string
}): Validation.FailureReport[] => {
  return failures.flatMap((failure) => {
    if (failure.failures) {
      return buildFailureReport({
        api,
        element,
        expectation,
        failures: failure.failures,
        path: buildElementPath({ key: failure.key, path }),
      })
    }

    if (typeof failure.reason === `string`) {
      return {
        expectation,
        failure,
        path,
        reason: failure.reason,
        value: failure.element,
      }
    }

    if (api.debugEnabled()) {
      api.privateFunctions.debug(
        `buildFailureReport: failure.failures is blank but reason is not a string`,
        {
          element,
          expectation,
          failure,
          path,
        }
      )
    }

    return {
      expectation,
      path,
      reason: JSON.stringify(failure.reason),
      value: failure.element,
    }
  })
}
